import { render, staticRenderFns } from "./create-manufacturer-form.vue?vue&type=template&id=1f80e22c&"
import script from "./create-manufacturer-form.vue?vue&type=script&lang=ts&"
export * from "./create-manufacturer-form.vue?vue&type=script&lang=ts&"
import style0 from "./create-manufacturer-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports